import { useDispatch } from 'react-redux';
import { DropDownButton, DropdownItem, Icon, IconName } from '@optimus-web/core';
import { lt, showSuccessAlert, useTimezone } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { OverlayedLoader } from '@mews-commander/ui';
import { AvailabilityBlockReportFilterValues } from '../types';
import { navigateInModal } from '../../app';
import { useAvailabilityBlockReportContext } from '../tableStateContext';
import { prepareQueryParameters } from '../utils';
import { useReportExportMutation, useReportScheduleExportMutation } from '../queries/exportMutations';

interface Props {
    filterValues: AvailabilityBlockReportFilterValues;
}

export const AvailabilityBlockReportExportsButton = ({ filterValues }: Props) => {
    const resolveRoute = useResolveRoute();
    const timezone = useTimezone();
    const dispatch = useDispatch();

    const { tableState } = useAvailabilityBlockReportContext();

    const reportExportMutation = useReportExportMutation({
        onSuccess: () => {
            showSuccessAlert({ description: lt('ExportQueuedSuccessMessage') });
        },
    });
    const handleExportClick = () =>
        reportExportMutation.mutate(prepareQueryParameters(filterValues, tableState, timezone));

    const scheduleMutation = useReportScheduleExportMutation();
    const handleScheduleExportClick = async () => {
        const { scheduleId } = await scheduleMutation.mutateAsync(
            prepareQueryParameters(filterValues, tableState, timezone)
        );
        const url = resolveRoute(RouteName.AvailabilityBlockReportScheduleDetail, { query: { scheduleId } });
        dispatch(navigateInModal(url));
    };

    return (
        <>
            <OverlayedLoader show={reportExportMutation.isPending || scheduleMutation.isPending} />

            <DropDownButton variant="secondary" label={lt('Export')} size="medium">
                <DropdownItem
                    leftDetail={<Icon value={IconName.Exports} />}
                    label={lt('ExportToExcel')}
                    onClick={handleExportClick}
                />
                <DropdownItem
                    leftDetail={<Icon value={IconName.ExportSchedule} />}
                    label={lt('CreateExportSchedule')}
                    onClick={handleScheduleExportClick}
                />
            </DropDownButton>
        </>
    );
};
